import loadable from '@loadable/component'

export * from './OutlookTable'
export const YearCell = loadable(() => import('./YearCell'))
export const RatingOutlookCell = loadable(() => import('./RatingOutlookCell'))
export const SectorOutlookCell = loadable(() => import('./SectorOutlookCell'))
export const CommentaryOutlookCell = loadable(
  () => import('./CommentaryOutlookCell')
)
export type {
  OutlookTableItemProps,
  ExcelSheetProps,
  excelItemProps,
  OutlookTableProps
} from './OutlookTable'
export type { YearCellProps } from './YearCell'
export type { RatingOutlookCellProps } from './RatingOutlookCell'
export type { SectorOutlookCellProps } from './SectorOutlookCell'
export type {
  CommentaryOutlookCellProps,
  CommentaryOutlookItemProps
} from './CommentaryOutlookCell'
